import uuidv4 from '@form-engine/core-util/uuid';
import z from 'zod';

export default z.object({
    id: z.string().nonempty().default(uuidv4),
    name: z.string().nonempty().default('NewPreset'),
    tags: z
        .string()
        .array()
        .optional()
        .default(() => []),
    description: z.string().default(''),
    data: z.any().default(null).nullable(),
});
